import { apiClient } from "../../utils/apiClient";
import { MenuOption } from "../../types/menuOption";

export const fetchMenuOptions = (): Promise<MenuOption[]> => {
    return apiClient.get("/menuOptions").then((response) => response.data);
};

export const upsertMenuOption = (menuOption: MenuOption): Promise<MenuOption> => {
    return apiClient.post("/menuOptions/upsertMenuOption", menuOption).then((response) => response.data);
};

export const getMenuOptionsByModuleId = (module_id: number): Promise<MenuOption[]> => {
    return apiClient.get(`/menuOptions/module/${module_id}`).then((response) => response.data);
}